import { call, put, race, select, take } from 'redux-saga/effects';
import {
  getMoreNotificationsError,
  getMoreNotificationsSuccess,
  getNotificationsError,
  getNotificationsSuccess,
  readAllNotificationsError,
  readAllNotificationsSuccess,
  readNotificationError,
  readNotificationSuccess,
  removeAllNotificationsError,
  removeAllNotificationsSuccess,
  removeNotificationError,
  removeNotificationSuccess,
  startNotificationsPolling,
} from 'modules/Notifications/redux/actions';
import { getNotifications, updateNotifications } from 'modules/Notifications/services/api';
import {
  NOTIFICATIONS_ALL,
  NOTIFICATIONS_ON_LOGIN,
  UPDATE_READ,
  UPDATE_REMOVE,
  UPDATE_SHOW,
} from 'modules/Notifications/constants';
import { onShowToastHandler } from 'modules/Notifications/utils';
import {
  actionTypes as siteMapActionTypes,
  startRequest as getSiteMap,
} from 'modules/App/redux/siteMap/actions';
import { selectSiteMap } from 'modules/App/utils/selectors';

const PAGE_ALL_SIZE = 15;

export function* notificationsSaga() {
  const { isOk, data, error } = yield call(getNotifications, {
    type: NOTIFICATIONS_ALL,
    size: PAGE_ALL_SIZE,
  });

  if (isOk) {
    yield put(getNotificationsSuccess(data));
  } else {
    yield put(getNotificationsError(error));
  }
}

export function* readNotificationSaga({ payload: { eventTypeId, notificationId } }) {
  const { isOk, data, error } = yield call(updateNotifications, UPDATE_READ, [
    {
      eventTypeId,
      notificationId,
    },
  ]);

  if (isOk) {
    yield put(readNotificationSuccess(data));
  } else {
    yield put(readNotificationError(error));
  }
}

export function* removeNotificationSaga({ payload: { eventTypeId, notificationId } }) {
  const { isOk, data, error } = yield call(updateNotifications, UPDATE_REMOVE, [
    {
      eventTypeId,
      notificationId,
    },
  ]);

  if (isOk) {
    yield put(removeNotificationSuccess(data));
  } else {
    yield put(removeNotificationError(error));
  }
}

export function* readAllNotificationsSaga() {
  const { isOk, data, error } = yield call(updateNotifications, UPDATE_READ);
  if (isOk) {
    yield put(readAllNotificationsSuccess(data));
  } else {
    yield put(readAllNotificationsError(error));
  }
}

export function* removeAllNotificationsSaga() {
  const { isOk, data, error } = yield call(updateNotifications, UPDATE_REMOVE);
  if (isOk) {
    yield put(removeAllNotificationsSuccess(data));
  } else {
    yield put(removeAllNotificationsError(error));
  }
}

export function* setWatchedSaga({ payload }) {
  yield call(updateNotifications, UPDATE_SHOW, payload);
}

export function* fetchMoreNotificationsSaga({ payload = {} }) {
  const { isOk, data, error } = yield call(getNotifications, {
    type: NOTIFICATIONS_ALL,
    size: PAGE_ALL_SIZE,
    ...payload,
  });

  if (isOk) {
    yield put(getMoreNotificationsSuccess(data));
  } else {
    yield put(getMoreNotificationsError(error));
  }
}

export function* onLoginNotificationsSaga() {
  yield getSiteMapSaga();

  const { isOk, data } = yield call(getNotifications, {
    type: NOTIFICATIONS_ON_LOGIN,
  });

  if (isOk) {
    const siteMap = yield select(selectSiteMap);
    const { notifications } = data;
    notifications && notifications.forEach(onShowToastHandler(siteMap));
  }
}

function* getSiteMapSaga() {
  yield put(getSiteMap());

  return yield race({
    success: take(siteMapActionTypes.REQUEST_SUCCESS),
    error: take(siteMapActionTypes.REQUEST_FAILURE),
  });
}

export function* initNotifications() {
  yield getSiteMapSaga();
  yield put(startNotificationsPolling());
}
